import querystring from 'querystring';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useParseURLQueryParams = () => {
  const searchString = useLocation().search.slice(1);

  const query: any = querystring.parse(useLocation().search.slice(1));

  const storeName: any = query?.store_name && `store_name=${query.store_name}`;

  const rawQueryParams: any = useMemo(() => {
    if (searchString) {
      return querystring.parse(searchString);
    } else {
      return {};
    }
  }, [searchString]);

  const serializedStoreName = useMemo(() => {
    if (rawQueryParams?.store_name) {
      return querystring.stringify({
        store_name: rawQueryParams.store_name,
      });
    } else {
      return '';
    }
  }, [rawQueryParams?.store_name]);

  return {
    /**@deprecated Replace by `rawQueryString and serializedAllQueryParams` */
    query,
    /**@deprecated Replace by `serializedStoreName` */
    storeName,
    serializedStoreName,
    rawQueryParams,
    serializedAllQueryParams: searchString,
  };
};
